import * as React from 'react';
import cx from 'classnames';

import { Clickable } from '../../../../components/Clickable/Clickable';
import { Icon } from '../../../../components/Icon/Icon';
import { useSiteMetadata } from '../../../../utils/useSiteMetadata';

import * as cs from './SocialsNavigation.module.css';

const SOCIALS = ['twitter', 'linkedin', 'github', 'youtube'];

interface Props {
  mobileOnly?: boolean;
}

export const SocialsNavigation = ({ mobileOnly }: Props) => {
  const siteMetadata = useSiteMetadata();

  return (
    <>
      {SOCIALS.map((entry) => (
        <Clickable
          className={cx(cs.linkWrapper, { [cs.mobileOnly]: mobileOnly })}
          key={entry}
          to={siteMetadata[entry]}
          target="_blank"
          aria-label={`Follow us on ${entry}`}
          trackEvent={`primary-navigation-${entry}`}
          rel="noopener noreferrer me"
        >
          <div className={cs.link}>
            <Icon name={entry} size={24} className={cs.icon} />
          </div>
        </Clickable>
      ))}
    </>
  );
};
